export default "__VITE_ASSET__55794289__"